import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useDeviceType } from '@cian/ui-kit';

import * as styles from './BankList.css';
import { IBank } from '../../types/promosPage';
import { BankItem } from '../BankItem';
import { RoundArrowLeft } from '../RoundArrowLeft';
import { RoundArrowRight } from '../RoundArrowRight';
import { Section } from '../Section';
import { VerticalSlider } from '../VerticalSlider';

interface IBankListProps {
  banks: IBank[];
  onListShow(): void;
  onItemClick(bank: IBank): void;
}

export const BankList: React.FC<IBankListProps> = ({ banks, onListShow, onItemClick }) => {
  const itemGap = useDeviceType() === 'phone' ? '12px' : '24px';

  return (
    <Section title="От банков" data-testid="BankListSection">
      <ActionAfterViewObserver triggerOnce callback={onListShow} wrapper={false}>
        <div className={styles['container']}>
          <VerticalSlider leftArrow={RoundArrowLeft} rightArrow={RoundArrowRight} itemGap={itemGap} arrowTopOffset={8}>
            {banks.map(bank => {
              return (
                <div key={bank.id} className={styles['slide']}>
                  <BankItem title={bank.title} logo={bank.logo} bankId={bank.id} onClick={() => onItemClick(bank)} />
                </div>
              );
            })}
          </VerticalSlider>
        </div>
      </ActionAfterViewObserver>
    </Section>
  );
};
